export function formatFloat(value: any) {
    const num = parseFloat(value);
    if (isNaN(num)) return value;
  
    return new Intl.NumberFormat('nl-NL', { }).format(num);
  }
  